import { MixpanelContext } from "@hooks/MixpanelProvider";
import { EVENTS } from "@utils/mixpanel_utilities";
import { useContext } from "react";
import { useMatch } from "react-router-dom";

const TermsOfUse = () => {
  const match = useMatch("/signup/brand");
  const { trackEvent } = useContext(MixpanelContext);

  const handleSupportClick = () => {
    trackEvent(EVENTS.SUPPORT.REQUESTED, {
      source: "auth_layout",
      method: "email",
      email: "support@fohr.co",
    });
  };

  return (
    <div className="text-center mt-8 text-white c-lg:text-black">
      <div className="mb-2">
        <p className="text-xs opacity-75 c-lg:opacity-50">
          Need additional help? Please reach out to{" "}
          <a
            className="underline"
            href="mailto:support@fohr.co"
            onClick={handleSupportClick}
          >
            support@fohr.co
          </a>
        </p>
      </div>
      <div className="text-xs mb-2 opacity-75 c-lg:opacity-50 max-w-[400px] mx-auto">
        By continuing, you acknowledge that you understand and agree to the{" "}
        {match && (
          <a
            href="https://www.fohr.co/terms-app-users"
            target="_blank"
            className="underline"
          >
            Apps Terms of Services
          </a>
        )}{" "}
        ,
        <a
          href="https://www.fohr.co/terms"
          target="_blank"
          className="underline"
        >
          Terms of Service
        </a>{" "}
        and{" "}
        <a
          href="https://www.fohr.co/privacy"
          target="_blank"
          className="underline"
        >
          Privacy Policy
        </a>
      </div>
    </div>
  );
};

export default TermsOfUse;
